import { Injectable } from '@angular/core';
import { UserManager, WebStorageStateStore } from 'oidc-client';
import { AppConfigService } from 'src/app/config/app-config.service';
import { AppConfig } from '../../../config/app-config';
import { SessionCookieStore } from '../session-cookie-store/session-cookie-store.service';

@Injectable({
  providedIn: 'root',
})
export class UserManagerAccessorService {
  private manager: UserManager;

  constructor(
    private appConfigService: AppConfigService,
    private cookieStorageService: SessionCookieStore
  ) {}

  initialize() {
    const baseUrl = window.location.origin;
    const config: AppConfig = this.appConfigService.getConfig();
    this.manager = new UserManager({
      authority: config.identityServerUrl,
      client_id: config.identityServerClientId,
      redirect_uri: baseUrl + '/callback',
      response_type: 'id_token token',
      scope: 'openid profile BOM',
      post_logout_redirect_uri: baseUrl,
      accessTokenExpiringNotificationTime: config.accessTokenExpiringNotificationTime,
      silent_redirect_uri: baseUrl + '/assets/oidc/silent-renew.html',
      silentRequestTimeout: config.silentRequestTimeout * 1000,
      userStore: new WebStorageStateStore({ store: this.cookieStorageService }),
      checkSessionInterval: config.checkSessionInterval,
    });
  }

  getManager(): UserManager {
    return this.manager;
  }
}
